export default "__VITE_PUBLIC_ASSET__2a141999__"